module.exports = __webpack_public_path__ + "assets/img/search_1.914571c9.png";